module.exports = {
  proxyTarget: process.env.REACT_APP_PROXY_TARGET,
  gaProps: {
    id: process.env.REACT_APP_GA_TRACKING_ID,
    debug: false
  }
};
